const documents = {
    ASNEF: "asnef",
    EXPERIAN: "experian",
    SOLIDARITY_EXTRACTS: "extracto-solidario",
    annualInformationValue: "555",
    legalCorrespondenceValue: "556",
    fiscalInformationValue: "901",
    mifid2DocumentInitialPageLoad: 3,
    mifid2DocumentPageSize: 10,
    mifid2GroupNumber: "9999",
};

module.exports = documents;
